import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/job-market/benefits-calculator/page.tsx");
